const LAYER_DEFS = [
  { id: "bun-top", exploded: -52 },
  { id: "lettuce", exploded: -24 },
  { id: "cheese", exploded: 0 },
  { id: "patty", exploded: 24 },
  { id: "bun-bottom", exploded: 48 },
];

const BunTop = () => (
  <g>
    <path
      d="M30 78 C30 34 82 18 130 18 C178 18 230 34 230 78 L230 82 Q230 88 222 88 L38 88 Q30 88 30 82 Z"
      fill="#FF9F1C"
    />
    <ellipse cx="80" cy="40" rx="7" ry="4" fill="#FFF3D6" transform="rotate(-14 80 40)" />
    <ellipse cx="120" cy="30" rx="7" ry="4" fill="#FFF3D6" transform="rotate(6 120 30)" />
    <ellipse cx="162" cy="36" rx="7" ry="4" fill="#FFF3D6" transform="rotate(14 162 36)" />
    <ellipse cx="196" cy="52" rx="7" ry="4" fill="#FFF3D6" transform="rotate(24 196 52)" />
    <ellipse cx="105" cy="34" rx="40" ry="10" fill="#FFFFFF" opacity="0.3" transform="rotate(-8 105 34)" />
  </g>
);

const Lettuce = () => (
  <path
    d="M28 90 H232 V96 C220 108 208 96 196 104 C184 112 172 98 160 104 C148 110 136 98 124 104 C112 110 100 98 88 104 C76 110 64 98 52 104 C40 110 32 100 28 98 Z"
    fill="#2EC4B6"
  />
);

const Cheese = () => (
  <path
    d="M34 102 H226 V110 C218 112 212 118 208 124 C202 132 192 128 190 118 C188 110 176 112 172 120 C168 128 158 126 156 116 C154 108 140 110 138 118 C136 126 124 126 122 116 C120 108 106 110 104 118 C102 126 90 126 88 116 C86 108 72 110 70 118 C68 126 56 124 54 116 C52 108 34 112 34 110 Z"
    fill="#FFD166"
  />
);

const Patty = ({ color = "#E63946", dark = "#C92030" }) => (
  <g>
    <rect x="30" y="114" width="200" height="30" rx="15" fill={color} />
    <ellipse cx="80" cy="124" rx="26" ry="6" fill="#FFFFFF" opacity="0.28" />
    <circle cx="180" cy="128" r="3" fill={dark} />
    <circle cx="150" cy="134" r="2.4" fill={dark} />
    <circle cx="200" cy="124" r="2.4" fill={dark} />
  </g>
);

const BunBottom = () => (
  <g>
    <path d="M34 144 H226 L222 158 Q220 166 208 166 L52 166 Q40 166 38 158 Z" fill="#FF9F1C" />
    <ellipse cx="90" cy="152" rx="30" ry="5" fill="#FFFFFF" opacity="0.3" />
  </g>
);

const Heart = () => (
  <path
    d="M130 6 C124 -4 106 -2 106 10 C106 20 122 28 130 34 C138 28 154 20 154 10 C154 -2 136 -4 130 6 Z"
    fill="#F75C82"
    transform="translate(0,8)"
  />
);

const LAYER_RENDER = {
  "bun-top": BunTop,
  lettuce: Lettuce,
  cheese: Cheese,
  patty: Patty,
  "bun-bottom": BunBottom,
};

export default function GummyBurger({
  variant = "classic",
  exploded = false,
  selected = null,
  onSelectLayer = null,
  className = "",
  title = "Ilustrasi gummy Yupi Burger",
}) {
  const isLove = variant === "love";
  const isMax = variant === "max";
  const interactive = typeof onSelectLayer === "function";

  return (
    <svg
      viewBox="0 0 260 220"
      role="img"
      aria-label={title}
      className={className}
      style={{ overflow: "visible" }}
    >
      <title>{title}</title>
      {isLove && <Heart />}
      {LAYER_DEFS.map((layer) => {
        const LayerSvg = LAYER_RENDER[layer.id];
        const offset = exploded ? layer.exploded : 0;
        const isSelected = selected === layer.id;
        const extraLayers = isMax && (layer.id === "patty" || layer.id === "cheese");
        return (
          <g
            key={layer.id}
            data-layer={layer.id}
            onClick={interactive ? () => onSelectLayer(layer.id) : undefined}
            style={{
              transform: `translateY(${offset}px) ${isSelected ? "scale(1.03)" : ""}`,
              transition: "transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1)",
              cursor: interactive ? "pointer" : "default",
              filter: isSelected ? "drop-shadow(0 8px 14px rgba(43,16,85,0.25))" : undefined,
            }}
          >
            {layer.id === "patty" ? (
              <Patty color={isLove ? "#FF85A1" : "#E63946"} dark={isLove ? "#F75C82" : "#C92030"} />
            ) : (
              <LayerSvg />
            )}
            {extraLayers && layer.id === "patty" && (
              <g transform="translate(0,26)">
                <Patty color="#C92030" dark="#A01825" />
              </g>
            )}
            {interactive && (
              <rect x="10" y="-60" width="240" height="140" fill="transparent">
                <title>{layer.id}</title>
              </rect>
            )}
          </g>
        );
      })}
    </svg>
  );
}
